<template>
  <div class="Projects">
    <v-container fluid>
      <v-card xs12
        class="mx-auto elevation-12"
        :key="cardKey"
      >
        <v-toolbar
          color="primary"
          dark
        >
          <v-toolbar-title>
            Proyectos disponibles para {{ user.primer_nombre }}:
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="filter"
            label="Filtrar"
            color="white"
            append-outer-icon="search"
          ></v-text-field>

          <template v-if="projects"
            v-slot:extension
          >
            <v-tabs
              v-model="tabs"
              fixed-tabs
              color="transparent"
              slider-color="iK"
              :key="tabsKey"
            >
              <v-tab href="#tab-active">
                Proyectos Activos
              </v-tab>

              <v-tab href="#tab-inactive">
                Proyectos Inactivos
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-card v-if="!projects || projects.length < 1"
          class="mx-auto elevation-7"
        >
          <v-container
            fluid
            grid-list-lg
          >
            <v-layout row wrap>
              <v-flex xs12>
                <v-card
                  class="mx-auto elevation-7"
                >
                  <v-layout>
                    <v-flex xs5>
                      <v-img
                        :src="logo"
                        height="150px"
                        contain
                      ></v-img>
                    </v-flex>
                    <v-flex xs7>
                      <v-card-title primary-title>
                        <div>
                          <div class="headline font-weight-bold">
                            Lo siento {{ user.primer_nombre }}<br>
                            No tiene proyectos asociados
                          </div>
                        </div>
                      </v-card-title>
                    </v-flex>
                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions>
                    <v-btn
                      color="primary"
                      disabled
                      @click="loadOper(null)"
                    >
                      Cargar Opciones de Usuario
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <v-tabs-items v-else
          v-model="tabs"
        >
          <v-tab-item
            :value="'tab-active'"
          >
            <!-- TODO: mejorar codigo para evitar esta duplicidad -->
            <v-container grid-list-md fluid>
              <v-layout row wrap justify-center>
                <template
                  v-for="project in projects"
                >
                  <v-flex d-flex xs12 md4
                    v-if="project.estado && filterBy(project.nombre_proyecto)"
                    :key="project.nombre_proyecto"
                  >
                    <v-card class="mx-auto elevation-7">
                      <v-layout justify-space-between column fill-height>
                        <v-layout row wrap>
                          <!-- <v-flex xs12>
                            <v-card-text>
                              <v-img
                                :src="project.img"
                                height="7em"
                                contain
                              ></v-img>
                            </v-card-text>
                          </v-flex> -->

                          <v-flex xs5>
                            <v-card-text class="mb-0">
                              <v-img class="mx-2"
                                :src="project.img"
                                height="100px"
                                contain
                              ></v-img>
                            </v-card-text>
                          </v-flex>

                          <v-flex xs7>
                            <v-card-title>
                              <div class="headline font-weight-bold">{{ project.nombre_proyecto }} </div>
                            </v-card-title>
                          </v-flex>

                          <v-flex xs12>
                            <v-card-text class="my-0 py-0">
                              <b>Descripcion:</b> {{ project.descripcion }} <br>
                              <b>Coordinador:</b> {{ project.coordinador }} <br>
                              <b>Fecha Inicio:</b> {{ project.fecha_inicio }} <br>
                              <b>Fecha Fin:</b> {{ project.fecha_fin }} <br>
                            </v-card-text>
                          </v-flex>
                        </v-layout>

                        <v-divider></v-divider>

                        <v-card-actions class="mt-0 pt-0">
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-autocomplete class="mx-2 mb-0"
                                v-if="project.operativos && Object.keys(project.operativos).length > 1"
                                :items="Object.keys(project.operativos)"
                                label="Operativo"
                                v-model="oper[project.nombre_proyecto]"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs12>
                              <v-btn class="ml-2 mb-2"
                                large
                                :disabled="oper[project.nombre_proyecto] === null"
                                color="primary"
                                @click="loadOper(project, oper[project.nombre_proyecto])"
                              >
                                Reportes Operativo: <br>
                                {{ oper[project.nombre_proyecto] }}
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-tab-item>

          <v-tab-item
            :value="'tab-inactive'"
          >
            <!-- TODO: mejorar codigo para evitar esta duplicidad -->
            <v-container grid-list-md fluid>
              <v-layout row wrap justify-center>
                <template
                  v-for="project in projects"
                >
                  <v-flex d-flex xs12 md4
                    v-if="!project.estado && filterBy(project.nombre_proyecto)"
                    :key="project.nombre_proyecto"
                  >
                    <v-card class="mx-auto elevation-7">
                      <v-layout justify-space-between column fill-height>
                        <v-layout row wrap>
                          <!-- <v-flex xs12>
                            <v-card-text>
                              <v-img
                                :src="project.img"
                                height="7em"
                                contain
                              ></v-img>
                            </v-card-text>
                          </v-flex> -->

                          <v-flex xs5>
                            <v-card-text>
                              <v-img
                                :src="project.img"
                                height="150px"
                                contain
                              ></v-img>
                            </v-card-text>
                          </v-flex>

                          <v-flex xs7>
                            <v-card-title>
                              <div class="headline font-weight-bold">{{ project.nombre_proyecto }} </div>
                            </v-card-title>
                          </v-flex>

                          <v-flex xs12>
                            <v-card-text>
                              <b>Descripcion:</b> {{ project.descripcion }} <br>
                              <b>Coordinador:</b> {{ project.coordinador }} <br>
                              <b>Fecha Inicio:</b> {{ project.fecha_inicio }} <br>
                              <b>Fecha Fin:</b> {{ project.fecha_fin }} <br>
                            </v-card-text>
                          </v-flex>
                        </v-layout>

                        <v-divider></v-divider>

                        <v-card-actions class="mt-0 pt-0">
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-autocomplete class="mx-2 mb-0"
                                v-if="project.operativos && Object.keys(project.operativos).length > 1"
                                :items="Object.keys(project.operativos)"
                                label="Operativo"
                                v-model="oper[project.nombre_proyecto]"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs12>
                              <v-btn class="ml-2 mb-2"
                                large
                                :disabled="oper[project.nombre_proyecto] === null"
                                color="primary"
                                @click="loadOper(project, oper[project.nombre_proyecto])"
                              >
                                Reportes Operativo: <br>
                                {{ oper[project.nombre_proyecto] }}
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'Projects',

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.user = this.$store.state.user
    this.logo = this.$store.state.appConf.logo
    this.getProjects()
  },

  data: function () {
    return {
      logo: null,
      user: null,
      projects: null,
      cardKey: 0,
      oper: null,

      filter: '',

      tabs: null,
      tabsKey: 0
    }
  },

  watch: {
    '$store.state.user': function () {
      this.user = this.$store.state.user
      this.cardKey += 1
    }
  },

  methods: {
    /**
     * Obtiene la lista de los proyectos
     */
    getProjects () {
      let request = { // TODO: cambiar a paginado
        method: 'get',
        url: '/core/projects/',
        data: {}
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.projects = resp.data.results
          t.$store.commit('set_user_projects', resp.data.results)
          t.cardKey += 1
          t.createOperlist()
        })
        .catch(err => console.error(err))
    },

    /**
     * Carga el proyecto y su respectivo operativo
     * @param  {object} project   El proyecto a cargar
     * @param  {string} operation El operativo a usar
     */
    loadOper (project, operation) {
      let operID = project.operativos[operation]

      // solicita la información del operativo
      let request = {
        method: 'get',
        url: '/core/operational/' + operID,
        data: {}
      }

      let t = this
      // let rol = project.rol
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          let prjOper = {
            project: project,
            operation: resp.data
          }
          t.$store.commit('set_proyect', prjOper)
        })
        .catch(err => console.error(err))
    },

    /**
     * crea una lista de variables, para la selección del operativo del proyecto
     */
    createOperlist () {
      let operPrj = {}
      this.projects.forEach(function (project) {
        let opDef = null

        if (project.operativos) {
          if (Object.keys(project.operativos).length !== 1) {
            opDef = null
          } else {
            opDef = Object.keys(project.operativos)[0]
          }
        }

        operPrj[project.nombre_proyecto] = opDef
      })

      this.oper = operPrj
    },

    /**
     * Filtra por el nombre
     * @param  {string} name cadena para filtrar
     * @return {boolean}     resultado
     */
    filterBy (name) {
      if (this.filter.length > 0) {
        return name.toLowerCase().includes(this.filter.toLowerCase())
      }

      return true
    }

  }
}
</script>
